/**
 * Copyright © 2025 Farmlands Co-operative Society Limited. All rights reserved.
 *
 * This document contains confidential information and is the property of Farmlands.
 * Unauthorised reproduction or distribution of any part of this publication is prohibited without written consent.
 */

import React, { useEffect } from 'react';
import useMsalFunctions from '../../util/useMsalAuthFunctions';
import { Loader } from '../Loader';
import { selectIsCEUser } from '../../features/azure-b2c/storage';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { LOGOUT_CE_USER_ROUTE } from '../../util/routing';
import { TestIds } from '../../testIds';

const Logout: React.FC = () => {
  const { handleMsalLogout } = useMsalFunctions();
  const isCEUser = useSelector(selectIsCEUser);
  const navigate = useNavigate();

  useEffect(() => {
    if (isCEUser) {
      navigate(LOGOUT_CE_USER_ROUTE, { replace: true });
    } else {
      handleMsalLogout();
    }
  }, []);

  return <Loader title='Logout' data-testid={TestIds.feat.logout.loader} />;
};

export default Logout;
